module.exports = __webpack_public_path__ + "img/dwf_ch_thorgrim_0.ddaf6db4.png";